<div [formGroup]="locationForm" [class.show-errors]="showErrors">
  <div class="form-group">
    <label for="country" class="form-label required">Country</label>
    <div class="input-with-error">
      <cm-select class="form-input" id="country" formControlName="country" [options]="countries"
                 [class.is-invalid]="showErrors && locationForm.controls.country.errors"></cm-select>
      <div class="invalid-feedback">
        <ng-container *ngIf="locationForm.controls.country.errors?.required">Please select country.</ng-container>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label for="state" class="form-label" [class.required]="formState.state.required">State</label>
    <div class="input-with-error">
      <cm-select class="form-input" id="state" formControlName="state" [options]="states"
                 [class.is-invalid]="showErrors && locationForm.controls.state.errors"></cm-select>
      <div class="invalid-feedback">
        <ng-container *ngIf="locationForm.controls.state.errors?.required">Please select state.</ng-container>
      </div>
    </div>
  </div>
  <div class="form-group">
    <label for="city" class="form-label required">
      City
    </label>
    <div class="input-with-error">
      <cm-select class="form-input" id="city" formControlName="city" [options]="cities"
                 [class.is-invalid]="showErrors && locationForm.controls.city.errors"></cm-select>
      <div class="invalid-feedback">
        <ng-container *ngIf="locationForm.controls.city.errors?.required">Please select city.</ng-container>
      </div>
    </div>
  </div>
</div>
